import React, { useEffect, useState } from 'react'

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
	FormFeedback,
} from "reactstrap";
import axios from "axios";
import useForm from "../../formValidator/userForm";
import "./styles.css";

import Loader from '../../components/Loader'

import { STATES, DISTRICTS, BLOCKS, GRAM_PANCHAYAT } from '../../configs/urls'
import { STATUS_LIST } from '../../configs/constant'
import { getApi, postApi, putApi } from '../../services/api'
import { useHistory } from 'react-router-dom'

const GPOperations = (props) => {

	const [isRequesting, setIsRequestig] = useState(false)
	const [actionTitle, setActionTitle] = useState('Add Grampanchayat')
	const [states, setStates] = useState([])
	const [districts, setDistricts] = useState([])
	const [blocks, setBlocks] = useState([])
	const history = useHistory()

	useEffect(() => {
		getAllData()
		if (props.match && props.match.params && !props.match.params.gp_id) {
			params.status = 1
		}
	}, [])

	const getAllData = () => {
		setIsRequestig(true);

		const states = getApi(STATES);
		const districts = getApi(DISTRICTS);
		const blocks = getApi(BLOCKS);
		let gramPanchayat;

		if (props.match && props.match.params && props.match.params.gp_id) {
			gramPanchayat = getApi(GRAM_PANCHAYAT + "/" + props.match.params.gp_id);
			setActionTitle('Update Grampanchayat')
		}

		axios
			.all([states, districts, blocks, gramPanchayat])
			.then((res) => {


				if (res[0] && res[0].data) {
					setStates(res[0].data)
				}

				if (res[1] && res[1].data) {
					setDistricts(res[1].data)
				}

				if (res[2] && res[2].data) {
					setBlocks(res[2].data)
				}

				if (res[3] && res[3].data) {
					const {
						name,
						status,
						state_id,
						district_id,
						block_id
					} = res[3].data;
					params.name = name;
					params.status = status;
					params.state_id = state_id;
					params.district_id = district_id;
					params.block_id = block_id;
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequestig(false)
			})
	};

	const validate = (values) => {
		let errors = {};

		if (!values.name) {
			errors.name = "Block Name is required";
		}

		if (!values.state_id || values.state_id < 0) {
			errors.state_id = "Please select state";
		}

		if (!values.district_id || values.district_id < 0) {
			errors.district_id = "Please select District";
		}

		if (!values.block_id || values.block_id < 0) {
			errors.block_id = "Please select Block";
		}

		if (!values.status || values.status < 0) {
			errors.status = "Please select Block Status";
		}

		return errors;
	};

	const saveUpdateDistrict = () => {

		setIsRequestig(true);

		if (props.match && props.match.params && props.match.params.gp_id) {
			putApi(`${GRAM_PANCHAYAT}/${props.match.params.gp_id}`, params).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequestig(false);
			});
		} else {
			postApi(GRAM_PANCHAYAT, params)
				.then(
					(res) => {
						history.goBack()
					},
					(err) => { }
				)
				.finally(() => {
					setIsRequestig(false);
				});
		}
	}

	const { params, errors, handleChange, handleSubmit } = useForm(
		saveUpdateDistrict,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<form onSubmit={handleSubmit}>
				<Card className="card-user">
					<CardHeader>
						<CardTitle tag="h5">{actionTitle}</CardTitle>
					</CardHeader>
					<hr />
					<CardBody>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="stateName">State</Label>
									<Input
										type="select"
										name="state_id"
										id="stateName"
										value={params.state_id}
										onChange={handleChange}
										invalid={errors.state_id && errors.state_id.length > 0 ? true : false}
									>
										<option value={-1}>Select State</option>
										{
											states.map(state => (
												<option key={state.id} value={state.id}>{state.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.state_id}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="districtName">District</Label>
									<Input
										type="select"
										name="district_id"
										id="districtName"
										value={params.district_id}
										onChange={handleChange}
										invalid={errors.district_id && errors.district_id.length > 0 ? true : false}
									>
										<option value={-1}>Select District</option>
										{
											districts.map(district => (
												<option key={district.id} value={district.id}>{district.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.district_id}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="block_id">Block</Label>
									<Input
										type="select"
										name="block_id"
										id="block_id"
										value={params.block_id}
										onChange={handleChange}
										invalid={errors.block_id && errors.block_id.length > 0 ? true : false}
									>
										<option value={-1}>Select Block</option>
										{
											blocks.map(block => (
												<option key={block.id} value={block.id}>{block.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.block_id}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<label>Gram Panchayat Name</label>
									<Input
										type="text"
										name="name"
										placeholder="Gram Panchayat Name"
										value={params.name || ""}
										onChange={handleChange}
										invalid={errors.name && errors.name.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.name}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="status">Status</Label>
									<Input
										type="select"
										name="status"
										id="status"
										value={params.status}
										onChange={handleChange}
										invalid={errors.status && errors.status.length > 0 ? true : false}
									>
										{
											STATUS_LIST.map(status => (
												<option key={status.id} value={status.id}>{status.title}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.status}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<div className="update ml-auto mr-auto">
								<Button
									className="btn-round"
									color="primary"
									type="submit"
								>
									{actionTitle}
								</Button>
							</div>
						</Row>
					</CardBody>
				</Card>
			</form>
		</div>
	)
}

export default GPOperations